import React, { createContext, useContext, useState, useEffect } from 'react';

const ChatContext = createContext();

export const ChatProvider = ({ children }) => {
  const [memory, setMemory] = useState(() => {
    const stored = localStorage.getItem('daisy-memory');
    return stored ? JSON.parse(stored) : {};
  });

  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem('daisy-user');
    return stored ? JSON.parse(stored) : null;
  });

const [loading, setLoading] = useState(true);

useEffect(() => {
  const storedUser = localStorage.getItem('daisy-user');
  if (storedUser) {
    setUser(JSON.parse(storedUser));
  }
  setLoading(false);
}, []);


  const updateMemory = (key, value) => {
    setMemory(prev => {
      const updated = { ...prev, [key]: value };
      localStorage.setItem('daisy-memory', JSON.stringify(updated));
      return updated;
    });
  };

  const updateUser = (newUser) => {
    setUser(newUser);
    localStorage.setItem('daisy-user', JSON.stringify(newUser));
  };

  const resetUser = () => {
    localStorage.removeItem('daisy-user');
    setUser(null);
  };

  return (
    <ChatContext.Provider value={{ memory, updateMemory, user, updateUser, resetUser, loading }}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChat = () => useContext(ChatContext);
